const LEGACY_PAYMENT_FILTERS = new Set(["unpaid", "partially_paid", "paid"]);
const UNIFIED_PAYMENT_FILTERS = new Set(["partially_paid", "paid"]);
const WORKFLOW_STATUS_VALUES = new Set([
  "ready_to_invoice",
  "invoiced",
  "in_production",
  "shipped",
  "closed",
  "all",
]);

export const CLIENT_INVOICING_SO_STATUS_OPTIONS = [
  ["ready_to_invoice", "Ready to be Invoiced"],
  ["invoiced", "Invoiced"],
  ["in_production", "In Production"],
  ["shipped", "Shipped"],
  ["closed", "Closed"],
  ["all", "All"],
];

export const CLIENT_INVOICING_STATUS_OPTIONS = [
  ["ready_to_invoice", "Ready to be Invoiced"],
  ["invoiced", "Invoiced"],
  ["in_production", "In Production"],
  ["shipped", "Shipped"],
  ["closed", "Closed"],
  ["partially_paid", "Partially Paid"],
  ["paid", "Paid"],
  ["all", "All"],
];

export const CLIENT_INVOICING_STATUS_COLUMN_LABELS = {
  salesOrderStatus: "Status",
  paymentCoverageStatus: "Payment Status",
};

export const normalizeClientInvoicingStatusFilters = (filters = {}) => {
  const requestedSoStatus = String(filters?.soStatus || "ready_to_invoice").trim();
  const hasLegacyPaymentFilter = LEGACY_PAYMENT_FILTERS.has(requestedSoStatus);
  return {
    ...filters,
    soStatus: hasLegacyPaymentFilter ? "all" : requestedSoStatus,
    paymentStatus: String(
      filters?.paymentStatus || (hasLegacyPaymentFilter ? requestedSoStatus : "all")
    ).trim(),
  };
};

export const getClientInvoicingReportRequestFilters = (filters = {}) =>
  normalizeClientInvoicingStatusFilters(filters);

export const getClientInvoicingUnifiedStatus = (filters = {}) => {
  const normalized = normalizeClientInvoicingStatusFilters(filters);
  if (normalized.soStatus === "all" && UNIFIED_PAYMENT_FILTERS.has(normalized.paymentStatus)) {
    return normalized.paymentStatus;
  }
  if (WORKFLOW_STATUS_VALUES.has(normalized.soStatus)) return normalized.soStatus;
  return "ready_to_invoice";
};

export const getClientInvoicingFiltersForUnifiedStatus = (status, filters = {}) => {
  const requestedStatus = String(status || "ready_to_invoice").trim();
  if (UNIFIED_PAYMENT_FILTERS.has(requestedStatus)) {
    return {
      ...filters,
      soStatus: "all",
      paymentStatus: requestedStatus,
    };
  }
  return {
    ...filters,
    soStatus: WORKFLOW_STATUS_VALUES.has(requestedStatus) ? requestedStatus : "ready_to_invoice",
    paymentStatus: "all",
  };
};
